import { StatisticsStorage } from '../storage/statistics_storage.js';
import { AuthSessionStore } from './auth_session.js';
import { updatePlayer } from './requests/player.requests.js';
import { localToServer } from './player_sync.js';
import type { UpdatePlayerRequest } from './dto/player.dto.js';
import type { GameStatistics } from "../storage/statistics_storage.js";

function buildServerPatch( partial: Partial<GameStatistics> ): UpdatePlayerRequest
{
  const patch: UpdatePlayerRequest = {};

  if ( 'seen_level' in partial && partial.seen_level !== undefined )
    patch.last_seen_level = Math.max( 1, partial.seen_level );

  if ( 'music_enabled' in partial && partial.music_enabled !== undefined )
    patch.music_enabled = partial.music_enabled;

  if ( 'sounds_enabled' in partial && partial.sounds_enabled !== undefined )
    patch.sounds_enabled = partial.sounds_enabled;

  return patch;
}

export const PlayerSyncService = {
  async onStatUpdate( partial: Partial<GameStatistics> ): Promise<void>
  {
    if ( !AuthSessionStore.isLoggedIn() )
    {
      console.warn( '[PlayerSync] onStatUpdate skipped — not logged in' );
      return;
    }

    const server_patch = buildServerPatch( partial );
    if ( Object.keys( server_patch ).length === 0 ) return;

    try
    {
      await updatePlayer( server_patch );
    }
    catch ( e )
    {
      console.warn( '[PlayerSync] onStatUpdate failed', e );
    }
  },

  async syncNow(): Promise<void>
  {
    if ( !AuthSessionStore.isLoggedIn() )
    {
      console.warn( '[PlayerSync] syncNow skipped — not logged in' );
      return;
    }
    try
    {
      const stats = StatisticsStorage.load();
      await updatePlayer( localToServer( stats ) );
    }
    catch ( e )
    {
      console.warn( '[PlayerSync] syncNow failed', e );
    }
  },
};
